import "./App.css";
import CustomerSupportScreen from "./Screen/CustomerSupportScreen";

function App() {
  return (
    <div className="App">
      <CustomerSupportScreen />
    </div>
  );
}

export default App;
